// External dependencies
// import SvgYoutubeIcon from '@svg/youtube_icon';
import { Div, Text } from 'atomize';
import React from 'react';
import { Trans } from 'react-i18next';

// Local dependencies
// import youtubeIcon from '../../../../svg/youtubeIcon.svg';

interface MeducationReviewCardProps {
  avatar: string;
  author: string;
  text: string;
  videoLink?: string;
}

export default function MeducationReviewCard({
  avatar,
  author,
  text,
  videoLink,
}: MeducationReviewCardProps) {
  return (
    <Div
      w={{ md: '387px' }}
      h={{ xs: 'auto', md: '100%' }}
      bg="white"
      className="meducation-reviews__card"
      p={{
        y: { xs: '24px', md: '36px' },
        x: { xs: '16px', md: '24px' },
      }}
      rounded="30px"
    >
      <Div textAlign="center">
        <img src={avatar} alt="" />
      </Div>
      <Text
        m={{ t: { xs: '24px', md: '36px' } }}
        textSize="display1"
        textWeight="500"
        textColor="text_gray"
        style={{ letterSpacing: '0.2px' }}
      >
        <Trans>{author}</Trans>
      </Text>
      <Div overflow="auto">
        <Text
          m={{ y: '16px' }}
          maxH="230px"
          textSize="display1"
          textWeight="500"
          textColor="bg_black"
          style={{ letterSpacing: '0.2px' }}
        >
          <Trans>{text}</Trans>
        </Text>
      </Div>
      {/* <Div>
        <a href={videoLink} target="_blank">
          <Div cursor="pointer" d="flex" align="center" style={{ gap: '8px' }}>
            <img src={youtubeIcon} />
            <Text
              d="inline"
              textSize="display1"
              textWeight="500"
              textColor="primary"
              style={{ letterSpacing: '0.2px' }}
            >
              <Trans>watchVideoReview</Trans>
            </Text>
          </Div>
        </a>
      </Div> */}
    </Div>
  );
}
